import { Component, Input, OnInit, ChangeDetectorRef, SimpleChanges, Inject, Optional } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output, OnChanges } from '@angular/core';
import { consts } from '../../../consts';
import { AddFileService } from '../../../shared/components/add-file/add-file.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { AccountingAccountsModel } from '../../accounting/accounting-accounts/accounting-accounts.model';
import { InvestmentFinancialModel } from './investment-financial.model';
import { AccountMovementsViewModel } from '../../accounting/models/accounting-movement.model';
import { AccountingMovementsImportComponent } from '../../accounting/movements/import/accounting-movements-import.component';
import { TurnosService } from '../../../services/employees/turnos.service';
import { Router } from '@angular/router';
import { InvestmentFinancialService } from './investment-financial.service';
import { AccountingAccountsService } from '../../accounting/accounting-accounts/accounting-accounts.service';
import { SharedService } from '../../../shared/services/shared.service';
import { InvestmentFinancialDialogImportAccount } from './investmentFinancial-dialog-importAccount.component';

@Component({
    selector: 'convfact-investment-financial-form',
    templateUrl: './investment-financial-form.component.html',
    styleUrls: ['./investment-financial.component.css'],
    standalone: false
})
export class InvestmentFinancialFormComponent implements OnInit, OnChanges {

  @Input() investmentFinancial: InvestmentFinancialModel;
  @Output() onSave = new EventEmitter<any>();
  @Input() errors: object;
  @Input() accounts: AccountingAccountsModel[] = [];

  public originEntity: string = consts.INVESTMENT_ENTITY;
  public filePath: string = consts.INVESTMENT_FILE_PATH;

  public loading = false;
  public ready = false;

  public imageTempUrl: any = '';

  public readyLoadedFiles: boolean = null;

  //AccountMovementes Import data
  flagImport: boolean = false;
  movement: AccountMovementsViewModel;
  type: string;
  saved: boolean = false;
  //------------------------------
  accountsAccounting: AccountingAccountsModel[] = [];


  constructor(
    private addFileService: AddFileService,
    public snackBar: MatSnackBar,
    private ref: ChangeDetectorRef,
    private router: Router,
    private investmentFinancialService: InvestmentFinancialService,
    private accountingAccountsService: AccountingAccountsService,
    private sharedService: SharedService,
    public dialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRefImport: MatDialogRef<AccountingMovementsImportComponent>
  ) { }

  public ngOnInit(): void {
    if (this.data != null) {
      this.accountingAccountsService.getListInvestmentsFinancialAccounts()
        .then(data => {
          this.accountsAccounting = data;

          this.movement = this.data.movement;
          this.flagImport = this.data.flagImport;
          this.type = this.data.type;
          this.movement.type = this.type;
          this.investmentFinancial.investmentDescription = this.movement.reference;
          this.investmentFinancial.investmentDate = this.movement.date;
          this.investmentFinancial.investmentValue = this.movement.amount;
          this.investmentFinancial.accountingModelsNumber = this.movement.accountNumber;
          this.investmentFinancial.manualMovement = this.movement;

          this.sharedService.checkIfAccountNumberExists(this.movement.accountNumber, this.movement.type).then(response => {
            this.investmentFinancial.accountingModelsNumber = response;
            this.investmentFinancial.manualMovement.accountNumber = response;
            const accountNumber = this.accountsAccounting
              .find(x => x.number == this.investmentFinancial.accountingModelsNumber);

            if (accountNumber.id !== undefined) {
              this.investmentFinancial.accountingModelsId = Number(accountNumber.id);
            }
          })

        });
    }

    this.ready = true;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.investmentFinancial && changes.investmentFinancial.currentValue.isPdf != undefined) {
      if (this.investmentFinancial.isPdf) {
        this.readyLoadedFiles = false;
        this.addFileService.getImageFromFilesPDF(this.investmentFinancial.filesInvestmentUid, this.originEntity).then(result => {
          this.loadPdfBlob(result);
          this.readyLoadedFiles = true;
        });
      }
    }
    if (changes.investmentFinancial && changes.investmentFinancial.currentValue.isImage != undefined) {
      if (this.investmentFinancial.isImage) {
        this.readyLoadedFiles = false;
        this.addFileService.getImageFromFiles(this.investmentFinancial.filesInvestmentUid, this.originEntity).then(response => {
          this.createImageFromBlob(response);
          this.readyLoadedFiles = true;
        })
      }
    }
  }

  public save(): void {
    this.loading = true;
    let noError = true;

    if (this.investmentFinancial.accountingModelsId == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("Es necesario seleccionar una de las opciones del campo 'Tipo inversion'");
    }

    if (this.investmentFinancial.investmentValue == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Valor de inversion' es requerido");
    }

    if (this.investmentFinancial.investmentValue <= 0) {
      noError = false;
      this.loading = false;
      this.displayInfo("El valor de la inversion no puede ser menor o igual a 0");
    }

    if (this.investmentFinancial.investmentDate == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'fecha de inversión' es requerido");
    }

    if (this.investmentFinancial.investmentDescription == null || this.investmentFinancial.investmentDescription == '') {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Descripción' es requerido");
    }

    this.setDefaultsValues();

    if (noError) {
      if (this.data != null) {
        this.saveData(this.investmentFinancial);
      } else {
        this.onSave.emit(this.investmentFinancial);
        this.loading = false;
      }
    }
  }

  public saveData(investmentFinancial: InvestmentFinancialModel): void {
    this.investmentFinancialService.add(investmentFinancial)
      .then(response => {
        this.saved = true;
        this.closeDialog();
      },
        error => {
          //Si venimos de importar, y ya existe la inversión, preguntamos si queremos actualizar
          //la inversión ya existente
          if (error.error['message'].includes("ya se encuentra registrada") && this.data != null) {
            this.dialog.open(InvestmentFinancialDialogImportAccount, {
              // width: '20%',
              //height: '40%',
              data: {
                dataImport: this.investmentFinancial,
              }
            }).afterClosed().subscribe(result => this.closeDialog())
          }
        });
  }

  public createImageFromBlob(image: Blob): void {
    const reader = new FileReader();
    if (image) {
      reader.readAsDataURL(image);
      reader.onloadend = () => {
        this.imageTempUrl = reader.result;
        this.ref.detectChanges();
      }
      this.ref.detectChanges();
    }
  }

  public loadPdfBlob(data: Blob): void {
    this.imageTempUrl = data;
    this.ref.detectChanges();
  }

  public SetFileParameters(event): void {
    this.imageTempUrl = null;
    this.investmentFinancial.isImage = event.Image;
    this.investmentFinancial.isPdf = event.PDF;
    this.investmentFinancial.filesInvestmentUid = event.FileUid;

    if (event.File) {
      this.createImageFromBlob(event.File);
    }

    if (event.PDF) {
      this.loadPdfBlob(event.File);
    }
  }

  public setDefaultsValues(): void {
    if (this.investmentFinancial.netBookValue == null) {
      this.investmentFinancial.netBookValue = 0;
    }
    if (this.investmentFinancial.termInMonths == null) {
      this.investmentFinancial.termInMonths = 0;
    }
    if (this.investmentFinancial.percentageOfProfitabilityOrInterest == null) {
      this.investmentFinancial.percentageOfProfitabilityOrInterest = 0;
    }
    if (this.investmentFinancial.numberOfUnitsOrSharesInvested == null) {
      this.investmentFinancial.numberOfUnitsOrSharesInvested = 0;
    }
  }

  public changeToggleGeneratesReturns(event: MatSlideToggleChange) {
    if (event.checked) {
      this.investmentFinancial.generatesReturns = true;
    } else {
      this.investmentFinancial.generatesReturns = false;
    }
  }

  public checkImage(): void {
    if (this.investmentFinancial.filesInvestmentUid != null || this.investmentFinancial.isImage || this.investmentFinancial.isPdf) {
      this.addFileService.getImageFromFiles(this.investmentFinancial.filesInvestmentUid, this.originEntity).then(response => {
        this.createImageFromBlob(response);
      })
    }
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public returnToIndex(): void {
    this.router.navigate(['investment/financial']);
  }

  closeDialog() {
    this.dialogRefImport.close(this.saved);
  }

  public change(value: string) {
    const accountNumber = this.accounts.find(x => x.number === value);

    this.investmentFinancial.accountingModelsId = Number(accountNumber.id);
  }

}
